export default {
  namespaced: true,
  state: {
    premiumDialog: false,
  },
  getters: {
    getPremiumDialog(state) {
      return state.premiumDialog;
    },
  },
  actions: {
    setPremiumDialog(context, dialog) {
      context.commit('SET_PREMIUM_DIALOG', dialog);
    },
  },
  mutations: {
    SET_PREMIUM_DIALOG: (state, dialog) => {
      state.premiumDialog = dialog;
    },
  },
};
